import { StudentLayout } from './StudentLayout';
import { AppNavbar } from './AppNavbar';

import { useAuthStore } from '@/stores/authStore';
import { usePreviewStore } from '@/stores/previewStore';

export function AppLayout({ children }: { children: React.ReactNode }) {
  const role = useAuthStore((s) => s.user?.role);
  const previewActive = usePreviewStore((s) => s.active);

  // Students get the revamped dark shell (sidebar + topbar + drawer).
  // Non-student roles (org_admin / trainer / super_admin) who land on a shared
  // route (e.g. /dashboard, /problems, /profile) keep the simple role-filtered
  // top-nav — they must NOT get the student-only nav or the student batch API.
  // Exception: trainers / super admins in "preview as student" mode see the
  // student shell so their preview matches what students actually get.
  const previewingAsStudent = previewActive && (role === 'trainer' || role === 'super_admin');
  if (role === 'student' || previewingAsStudent) {
    return <StudentLayout>{children}</StudentLayout>;
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <AppNavbar />
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}
